import { appPaths } from "../../Common";
import { BreadcrumbMap } from "../../Layout";

export const breadcrumbsMap: BreadcrumbMap = {
  [appPaths.user.root]: {
    path: appPaths.user.root
  },
  [appPaths.user.settings]: {
    path: appPaths.user.settings
  },
  [appPaths.user.bugReports]: {
    path: appPaths.user.bugReports,
    replacements: [{ key: "bugreports", value: "Bug Reports" }]
  },
  [appPaths.user.featureRequests]: {
    path: appPaths.user.featureRequests,
    replacements: [{ key: "featurerequests", value: "Feature Requests" }]
  },
  [appPaths.user.resourceRequests]: {
    path: appPaths.user.resourceRequests,
    replacements: [{ key: "resourceRequests", value: "Resource Requests" }]
  },
  [appPaths.user.assigned]: {
    path: appPaths.user.assigned
  }
};
